import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Chip, Stack, Button } from '@mui/material';
import { FaBullhorn } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ImageIcon from '@mui/icons-material/Image';
import { fetchAnnouncements } from '../../controllers/announcementsController';
import { resolveAnnouncementAssetUrl } from '../../api/httpClientAnnouncements';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SonDuyurular = () => {
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        fetchAnnouncements({ pageNumber: 1, pageSize: 5 })
            .then(({ data }) => {
                if (!active) return;
                setAnnouncements(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                if (active) setError(e?.message || 'Duyurular alınamadı');
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    return (
        <Card sx={{ flex: '0 0 calc(50% - 16px)', minWidth: 300, border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
            <CardContent sx={{ p: 2.5 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: '50%',
                                backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <FaBullhorn style={{ fontSize: '18px', color: '#0E4D94' }} />
                        </Box>
                        <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#444444' }}>
                            Son Duyurular
                        </Typography>
                    </Stack>
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => navigate('/announcements')}
                        sx={{
                            textTransform: 'none',
                            fontSize: '13px',
                            fontWeight: 500,
                            backgroundColor: 'transparent',
                            color: '#0E4D94',
                            textDecoration: 'underline',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Tüm Duyurular
                    </Button>
                </Stack>

                {error ? (
                    <Typography color="error" sx={{ fontSize: '14px' }}>{error}</Typography>
                ) : loading ? (
                    <TableContainer>
                        <Table size="small">
                            <TableHead sx={{ bgcolor: 'transparent' }}>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Görsel</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Başlık</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Kategori</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Durum</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from({ length: 5 }).map((_, index) => (
                                    <TableRow
                                        key={`skeleton-${index}`}
                                        sx={{
                                            '& .MuiTableCell-root': {
                                                borderBottom: index === 4 ? 'none' : '1px dashed #e8e8e8',
                                                px: 1.5,
                                                py: 1.5,
                                            },
                                        }}
                                    >
                                        <TableCell>
                                            <Skeleton width={50} height={50} borderRadius={4} />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton width={200} height={20} />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton width={80} height={24} borderRadius={16} />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton width={70} height={24} borderRadius={16} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : announcements.length === 0 ? (
                    <Typography sx={{ fontSize: '14px', color: '#a3a3a3', textAlign: 'center', py: 2 }}>
                        Henüz duyuru bulunmamaktadır.
                    </Typography>
                ) : (
                    <TableContainer>
                        <Table size="small">
                            <TableHead sx={{ bgcolor: 'transparent' }}>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Görsel</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Başlık</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Kategori</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Durum</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {announcements.map((a, index) => (
                                    <TableRow
                                        key={a.id}
                                        hover
                                        sx={{
                                            '& .MuiTableCell-root': {
                                                borderBottom: index === announcements.length - 1 ? 'none' : '1px dashed #e8e8e8',
                                                px: 1.5,
                                                py: 1.5,
                                                color: '#444444',
                                                fontWeight: 500,
                                            },
                                        }}
                                    >
                                        <TableCell>
                                            {a.coverImageUrl ? (
                                                <Box
                                                    component="img"
                                                    src={resolveAnnouncementAssetUrl(a.coverImageUrl)}
                                                    alt={a.title}
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => navigate(`/announcements/${a.id}`)}
                                                />
                                            ) : (
                                                <Box
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        borderRadius: '4px',
                                                        backgroundColor: '#f5f5f5',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <ImageIcon sx={{ fontSize: 24, color: '#a3a3a3' }} />
                                                </Box>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ cursor: 'pointer' }} onClick={() => navigate(`/announcements/${a.id}`)}>
                                            {a.title}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={
                                                    a.category === 1 ? 'Etkinlik' :
                                                        a.category === 2 ? 'Proje' :
                                                            a.category === 3 ? 'Vefat' :
                                                                a.category === 4 ? 'Evlilik' :
                                                                    a.category === 5 ? 'Doğum' :
                                                                        a.category === 6 ? 'Yeni Üye Katılımı' :
                                                                            a.category === 7 ? 'Bayram Tebrikleri' : 'Genel'
                                                }
                                                sx={{
                                                    fontSize: '13px',
                                                    fontWeight: 400,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {a.isPublished ? (
                                                <Chip
                                                    label="Yayında"
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#DFFFEA',
                                                        color: '#17C653',
                                                        fontWeight: 600,
                                                        fontSize: '12px'
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="Taslak"
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#FFEEF3',
                                                        color: '#F8285A',
                                                        fontWeight: 600,
                                                        fontSize: '12px'
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </CardContent>
        </Card>
    );
};

export default SonDuyurular;
